import { useEffect } from 'react'

import useSubsidySettings from 'app/dataProviders/subsidy/settings/hooks/useSubsidySettings'

import { CategoryCafeteriaSettings } from './cafeteria/CategoryCafeteriaSettings'
import { CategoryCampSettings } from './camp/CategoryCampSettings'
import { CategoryCompensationSettings } from './compensation/CategoryCompensationSettings'

type Props = {
  ID: string
  orgID: string
  app: 'cafeteria' | 'camp' | 'compensation'
  onDataUpdate: () => void
  onCreateFormID: (ID: string) => string
  updateSize?: () => void
  onSuccess?: () => void
  onPending?: (pending: boolean) => void
  onModify?: () => void
}

export const CategorySettings = ({
  ID,
  orgID,
  app,
  onDataUpdate,
  onCreateFormID,
  updateSize,
  onSuccess,
  onPending,
  onModify,
}: Props) => {
  const [settings, loading] = useSubsidySettings({ orgID, app, allowanceID: ID })

  useEffect(() => {
    onDataUpdate()
  }, [settings]) // eslint-disable-line react-hooks/exhaustive-deps

  if (settings.app === 'cafeteria') {
    return (
      <CategoryCafeteriaSettings
        ID={ID}
        orgID={orgID}
        settings={settings}
        loading={loading}
        onDataUpdate={onDataUpdate}
        onCreateFormID={onCreateFormID}
        updateSize={updateSize}
        onSuccess={onSuccess}
        onPending={onPending}
        onModify={onModify}
      />
    )
  }

  if (settings.app === 'camp') {
    return (
      <CategoryCampSettings
        ID={ID}
        orgID={orgID}
        settings={settings}
        loading={loading}
        onDataUpdate={onDataUpdate}
        onCreateFormID={onCreateFormID}
        updateSize={updateSize}
        onSuccess={onSuccess}
        onPending={onPending}
        onModify={onModify}
      />
    )
  }

  if (settings.app === 'compensation') {
    return (
      <CategoryCompensationSettings
        ID={ID}
        orgID={orgID}
        settings={settings}
        loading={loading}
        onDataUpdate={onDataUpdate}
        onCreateFormID={onCreateFormID}
        updateSize={updateSize}
        onSuccess={onSuccess}
        onPending={onPending}
        onModify={onModify}
      />
    )
  }

  return null as never
}
